import type { Platform } from './types';

// Plain browser / future PWA: login by phone code, links in a new tab,
// notifications via web push (to be wired with the backend's push channel).
export function createWebPlatform(): Platform {
  return {
    name: 'web',
    canRequestPhone: false,
    credential: () => null,
    startRoute: () => null,
    preferredLanguage: () => navigator.language ?? null,
    ready() {},
    setBackButton() {},
    haptic() {},
    openExternal: (url) => window.open(url, '_blank', 'noopener'),
    requestPhone: async () => false,
    requestNotifications: async () => false,
  };
}
